import axios from "axios";
import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { getItem } from "../../Services/localService";
import { toast } from "react-toastify";
import Toast from "../../Components/Toast";
import { Eraser, Palette, Trash } from "lucide-react";
// import { SketchPicker } from "react-color";
// import ColorPicker from "../../Components/Sidebar/colorPicker";

const CreateSectionModal = ({ show, handleClose, sectionName,
    setSectionName, handleSave, url, setUrl, color, setColor }) => {

    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    let [loader, setLoader] = useState(false);
    let [showColorPicker, setShowColorPicker] = useState(false);

    const headers = (isMultipart = false) => {
        const header = {
            Authorization: `Bearer ${getItem("token")}`,
            "Content-Type": "application/json",
        }
        if (isMultipart) {
            header['Content-Type'] = 'multipart/form-data'
        }
        return header
    };

    let handleInputChange = async (e) => {
        setShowColorPicker(false)
        setLoader(true);
        setUrl(''); setColor('');
        const file = e.target.files?.[0];
        if (!file) { setUrl(''); setColor(''); setLoader(false); return };
        if (file) {
            try {
                // Create form data
                const formData = new FormData();
                formData.append("file", file);
                const res = await axios.post(`${BACKEND_URL}/form-sub-module/upload-form-img-file`, formData, { headers: headers(true) });
                if (res?.data?.success && res?.data?.s3Url) {
                    setLoader(false);
                    setUrl(res?.data?.s3Url);
                }
            } catch (err) {
                setLoader(false);
                toast.error(err?.response?.statusText, {
                    autoClose: 2000,
                })
            }
        }
    }

    return (
        <>
            <Toast />
            <Modal show={show} onHide={handleClose} backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Sidebar Section</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ height: '250px' }}>
                    {loader ?
                        <div className="section-modal-loader">
                            <Spinner animation="border" variant="primary" center />
                        </div>
                        :
                        <>
                            <label className="form-label">Section name</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Section name"
                                value={sectionName}
                                onChange={(e) => setSectionName(e.target.value)} />

                            <label className="form-label mt-2">Upload Icon</label>
                            <input
                                className="form-control"
                                type="file"
                                accept=".svg,image/svg+xml"
                                onChange={handleInputChange}
                            />

                            {url &&
                                <>
                                    <div className="d-flex align-items-center mt-2">
                                        <label className="form-label">Uploaded Icon</label>
                                        <img src={url} alt="icon" className="ms-3" />
                                        <div className="ms-auto d-flex gap-2">
                                            <Trash size={14} className="cursor-pointer" title="Remove icon" onClick={() => { setUrl(''); setColor('') }} />
                                            <Palette size={14} className="cursor-pointer" title="Change icon color" onClick={() => setShowColorPicker(!showColorPicker)} />
                                            {/* <span class="fw-semibold ms-3 cursor-pointer" title="Remove icon" onClick={() => { setUrl(''); setColor('') }}>x</span> */}
                                        </div>
                                    </div>
                                    {showColorPicker &&
                                        <div className="d-flex align-items-center">
                                            <label className="form-label mt-2">Change Icon Color</label>
                                            <div
                                                className="ms-3 me-3"
                                                style={{
                                                    width: 20,
                                                    height: 20,
                                                    backgroundColor: color || '#000000',
                                                    maskImage: `url(${url})`,
                                                    WebkitMaskImage: `url(${url})`,
                                                    maskRepeat: "no-repeat",
                                                    WebkitMaskRepeat: "no-repeat",
                                                    maskSize: "contain",
                                                    WebkitMaskSize: "contain"
                                                }}
                                            />
                                            <input
                                                type="color"
                                                value={color}
                                                onChange={(e) => setColor(e.target.value)}
                                                style={{
                                                    width: 30,
                                                    height: 20,
                                                    backgroundColor: color,
                                                    border: `1px solid ${color}`,
                                                    borderRadius: 6,
                                                    cursor: "pointer",
                                                    display: "block",
                                                    padding: 0,
                                                }}
                                            />
                                            <div className="ms-auto d-flex gap-2">
                                                <Eraser size={14} className="cursor-pointer" title="Revert" onClick={() => { setColor(''); setShowColorPicker(false) }} />
                                            </div>
                                        </div>
                                    }
                                </>
                            }
                        </>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                        onClick={handleSave} disabled={!sectionName || !url}
                    >
                        Save
                    </Button>
                    <Button variant="secondary"
                        onClick={handleClose}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
export default CreateSectionModal;